import { PecForm } from 'shell/components/shared/management-pec/pec-details/form';

export const initialValuesPecForm: PecForm = {
  assignedTo: '',
  cc: '',
  code: undefined,
  competentUnit: '',
  messageBody: '',
  messageDate: '',
  messageId: '',
  messageNumber: undefined,
  processingStatus: undefined,
  receiver: '',
  sendDate: '',
  sender: '',
  signedBy: '',
  subject: '',
  transmissionStatus: undefined,
  trasmissionStyleObject: undefined,
  descRecipient: '',
};
